<template>
	<svg
		id="custom_svg_lib"
		width="26.000000"
		height="26.000000"
		viewBox="0 0 26 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		
	>
		<defs />
		<path
			id="custom_svg_color"
			d="M11.83 26L11.83 14.15L0 14.15L0 11.84L11.83 11.84L11.83 0L14.15 0L14.15 11.84L26 11.84L26 14.15L14.15 14.15L14.15 26L11.83 26Z"
			fill="#FF6D2E"
			fill-opacity="1.000000"
			fill-rule="nonzero"
		/>
	</svg>
</template>
